// 音量ボタンの状態をチェックして、activeの動画の音量を変更する関数
export const checkVolumeButtonState = () => {
  const volumeIcon = window.storeeelItems.isMobile
    ? document.querySelector('.storeeel-menu-area-icons img[alt="volume"]')
    : document.querySelector('#volume-desktop');
  const activeVideo = document.querySelector(
    '.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper video'
  );
  if (activeVideo instanceof HTMLVideoElement) {
    if (volumeIcon.getAttribute('data-muted') === 'true') {
      activeVideo.muted = true;
    } else {
      activeVideo.muted = false;
    }
  }
}
